import { Component, OnInit } from '@angular/core';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { IMenuItem } from 'projects/shared/src/lib/models/IMenuItem';
import { NavigationEnd, Router } from '@angular/router';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  activeLinkId!: string;
  title = 'Squirrel 3.0';

  constructor(private router: Router,
    private oauthService: OAuthServiceService,
    private userProfileService: UserProfileService,
    private tenantService: TenantService) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activeLinkId = `/${event.urlAfterRedirects.substring(1)}`;
      }
    });
  }

  ngOnInit(): void {
    console.log('-------> app-root (app.component.ts) first')
    let path = window.location.pathname;

    console.log("----> path: ", path)
    console.log("----> window.location.origin: ", window.location.origin)
    //window.location.origin: https://localhost:4200 (in Entwicklungsumgebung)

    if (path !== window.location.origin) {

      console.log("--------> path !== window.location.origin")
      
      this.oauthService.checkAuth().subscribe({
        next: (isAuthenticated) => {
          if (!isAuthenticated) {
            console.log("----> not authenticated")
            this.tenantService.removeToken();
            this.userProfileService.currentUserName = ""; // neu eingeloggt
            this.tenantService.currentTenantName = "";
            // if (this.oauthService.isLoggedIn)
            // console.log("----> angemeldet: ", this.oauthService.isLoggedIn)
            // else
            // console.log("----> nicht angemeldet: ", this.oauthService.isLoggedIn)
//            setTimeout(() => {
              this.oauthService.doLogin();
//            }, 20000);
            //this.tenantService.getDefaultTenancy();
          }
          else{
            console.log("----> app.component: authenticated")
            //this.tenantService.getDefaultTenancy();            
          }
        },
        error: (error: any) => {
        console.log("----------> error this.oauthService.checkAuth()")
        } 
      });
    }   
  }

  get isAuthenticated() {
    console.log("----> is authenticated?")
    return this.oauthService.isLoggedIn;
  }
}